import { render, staticRenderFns } from "./Apostas.vue?vue&type=template&id=426a1eb6&scoped=true"
import script from "./Apostas.vue?vue&type=script&lang=js"
export * from "./Apostas.vue?vue&type=script&lang=js"
import style1 from "./Apostas.vue?vue&type=style&index=1&id=426a1eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426a1eb6",
  null
  
)

export default component.exports